import QueryWhereChild from '~/scripts/services/model/query-where-child';

export default class QueryColumn {
	/** @param {any} column */
	constructor(column = null) {
		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.class_kid = column?.class_kid ?? undefined;

		/** @type {string} */
		this.field = column?.field ?? '';

		/** @type {boolean} */
		this.hidden = column?.hidden ?? false;

		/** @type {string | undefined} */
		this.id = column?.id;

		/** @type {number} */
		this.inherits_extended = column?.inherits_extended ?? -1;

		/** @type {any} */
		this.kdata = {};
		if (column?.kdata) {
			this.kdata = {
				...column.kdata,
				where: new QueryWhereChild(column.kdata.where),
			};
		}

		/** @type {?(import('@knitiv/api-client-javascript').KNode | 'NONE')} */
		this.kid = column?.kid ?? null;

		/** @type {import('@knitiv/api-client-javascript').LinkerKNode} */
		this.linker_kid = column?.linker_kid ?? '0';

		/** @type {import('@knitiv/api-client-javascript').LinkerInfo | undefined} */
		this.linker_info = column?.linker_info;

		/** @type {string} */
		this.name = column?.name ?? '';

		/** @type {import('@knitiv/api-client-javascript').QueryNode} */
		this.node = column?.node ?? 'REPRE';

		/** @type {'detail' | 'count' | 'sum' | 'min' | 'avg' | 'max'} */
		this.op = column?.op ?? 'detail';

		/** @type {import('@knitiv/api-client-javascript').SelectionPath[]} */
		this.path = column?.path || [];

		/** @type {any} */
		this.repre = undefined;

		/** @type {boolean | undefined} */
		this.root = undefined;

		/** @type {any} */
		this.settings = column?.settings ?? {};

		/**
		 * @type {'fileThumb' | 'query' | 'rownum' | 'rowSelection' | 'virtual' | 'workflow' |
		 * import('@knitiv/api-client-javascript').TypeIdV4}
		 */
		this.type = column?.type ?? 'K_NODE;STRING';

		/** @type {boolean | undefined} */
		this.virtual = column?.virtual ?? false;

		/** @type {?number} */
		this.width = column?.width ?? null;
	}
}
